import {
  CORE_LOAD_ALL_PRODUCT_REQUEST,
  CORE_LOAD_ALL_PRODUCT_SUCCESS,
  CORE_LOAD_ALL_PRODUCT_FAILURE,

  CORE_LOAD_PRODUCT_REQUEST,
  CORE_LOAD_PRODUCT_SUCCESS,
  CORE_LOAD_PRODUCT_FAILURE,

  CORE_UPVERSION_PRODUCT_REQUEST,
  CORE_UPVERSION_PRODUCT_SUCCESS,

  REQUEST_STATE
} from '../types'

const initialState = []
  , initialStateObj = {}
  , requestState = REQUEST_STATE
  , versionState = {
    status: false,
    date: '',
    type: '',
    id: ''
  }
export default {
  allProduct: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALL_PRODUCT_REQUEST:
        return requestState
      case CORE_LOAD_ALL_PRODUCT_SUCCESS:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload
        } else return []
      case CORE_LOAD_ALL_PRODUCT_FAILURE:
        return initialState
      default:
        return state
    }
  },
  productInfo: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_PRODUCT_REQUEST:
        return requestState
      case CORE_LOAD_PRODUCT_SUCCESS:
        if (action.payload && typeof action.payload === 'object' && !Array.isArray(action.payload)) {
          return action.payload
        } else return {}
      case CORE_LOAD_PRODUCT_FAILURE:
        return initialStateObj
      default:
        return state
    }
  },
  versionProduct: (state = versionState, action) => {
    switch (action.type) {
      case CORE_UPVERSION_PRODUCT_REQUEST:
        return versionState
      case CORE_UPVERSION_PRODUCT_SUCCESS:
        return action.payload
      default:
        return state
    }
  },
}



// WEBPACK FOOTER //
// ./src/reducers/reducerProduct.js